import Analytics from "analytics";
import googleTagManager from "@analytics/google-tag-manager";

const analytics = Analytics({
  app: "NW",
  plugins: [
    googleTagManager({
      containerId: "GTM-KXN8TR",
    }),
  ],
});

export function sendGAEvent(options) {
  const allowedProperties = ["eventAction", "eventLabel", "eventCategory"];
  let eventOptions = options || {};

  if (!options) {
    const data = this.dataset;
    Object.keys(data)
      .filter((k) => allowedProperties.includes(k))
      .reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, eventOptions);
  }

  analytics.track("ua_event", eventOptions);

  if (process.env.NODE_ENV !== "production") {
    console.log(
      "Analytics event action=" +
        eventOptions.eventAction +
        ", label=" +
        eventOptions.eventLabel +
        " category=" +
        eventOptions.eventCategory,
    );
  }
}

const events = document.querySelectorAll('[data-event="dl"]');
(events || []).forEach((el) => {
  let stopPropagation = false;
  let event = "click";

  if (el.dataset.stopPropagation) {
    stopPropagation = true;
  }

  if (el.tagName == "FORM") {
    event = "submit";
  } else if (el.dataset.trigger) {
    event = el.dataset.trigger;
  }

  el.addEventListener(event, function (e) {
    if (stopPropagation) {
      e.stopPropagation();
    }
    sendGAEvent.call(this);
  });
});
